import ReactMarkdown from 'react-markdown';

import { MARKDOWN_COMPONENTS } from './markdownComponents';

import type { IMarkdownProps } from './markdown.type';

/**
 * Configured react-markdown
 */
export const Markdown = ({ children, components }: IMarkdownProps) => (
  <ReactMarkdown components={{ ...MARKDOWN_COMPONENTS, ...components }}>{children}</ReactMarkdown>
);
